import * as React from "react";
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    SimpleForm,
    DateField,
    DateTimeInput,
    TextInput,
    ReferenceInput,
    SelectInput
} from 'react-admin';
import { DefaultShowActions, DefaultListActions, DefaultEditCreateActions, DefaultPagination, DefaultListPerPage } from '../lib/defaultConfig'
import { DefaultFilterSidebar, UserIdFilter, GradeIdFilter } from "../components/ListFilters";

export const UserGradeList = props => (
    <List {...props} actions={<DefaultListActions import={true} resource={'user_grade'} />} pagination={<DefaultPagination />}
        perPage={DefaultListPerPage}
        aside={<DefaultFilterSidebar>
            <UserIdFilter />
            <GradeIdFilter />
        </DefaultFilterSidebar>}
    >
        <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="userId" fullWidth />
            <TextField source="gradeId" fullWidth />
            <DateField source="start" showTime locales="ru-RU" />
            <DateField source="end" showTime locales="ru-RU" />
        </Datagrid>
    </List>
);

const simpleForm =
    <SimpleForm>
        <TextInput source="userId" fullWidth />
        <ReferenceInput source="gradeId" reference="grade" fullWidth>
            <SelectInput optionText="name" />
        </ReferenceInput>
        <DateTimeInput source="start" locales="ru-RU" />
        <DateTimeInput source="end" locales="ru-RU" />
    </SimpleForm>

export const UserGradeEdit = props => (
    <Edit {...props} actions={<DefaultEditCreateActions />} mutationMode={'pessimistic'}>
        {simpleForm}
    </Edit>
);
export const UserGradeCreate = props => (
    <Create {...props} actions={<DefaultEditCreateActions />}>
        {simpleForm}
    </Create>
);